import { Component, OnInit, Input } from '@angular/core';

@Component({

  selector: 'sa-big-breadcrumbs',
  template: `
   <ol class="breadcrumb float-xl-start">
   <li class="breadcrumb-item"><a href="javascript:;"><i class="fa-fw fa fa-{{icon}}"></i><b>{{items[0]}} </b> </a></li>
   <li  *ngFor="let item of items.slice(1)" class="breadcrumb-item active">{{item}}</li>
</ol>
  `,
})
export class BigBreadcrumbsComponent implements OnInit {

  @Input() public icon: string;
  @Input() public items: Array<string>;


  constructor() { }

  ngOnInit() {
  }

}
